import Phaser from 'phaser';
import { appConfig } from '@config/app.config';
import { GameBootstrap, setBootstrap } from '@core/bootstrap/GameBootstrap';
import { ServiceTokens } from '@core/bootstrap/ServiceRegistry';
import type { LocalizationService } from '@localization/LocalizationService';
import { sceneKeys } from '@utils/constants';

/**
 * Bootstrap sahnesi — servisleri başlatır ve ana sahneye geçer.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super(sceneKeys.boot);
  }

  async create(): Promise<void> {
    const gameBootstrap = new GameBootstrap();
    setBootstrap(gameBootstrap);
    await gameBootstrap.start();

    const localization = gameBootstrap.registry.get<LocalizationService>(
      ServiceTokens.localization,
    );

    this.cameras.main.setBackgroundColor('#0f1115');
    this.add
      .text(appConfig.gameWidth / 2, appConfig.gameHeight / 2, localization.t('app.loading'), {
        fontFamily: 'Arial, sans-serif',
        fontSize: '32px',
        color: '#ffffff',
      })
      .setOrigin(0.5);

    this.scene.start(sceneKeys.mainMenu);
  }
}
